// extracted by mini-css-extract-plugin
module.exports =  {"root":"AnFXg8VJP60qYCGcy9WZ"};